import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleEntry from './components/ArticleEntry';
import TrustSection from './components/TrustSection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'USFansSpreadsheet',
      url: SITE_URL,
      description: 'Kompletny przewodnik i narzędzia USFansSpreadsheet 2026. Porównania, poradniki, bezpieczeństwo i rankingi.',
      inLanguage: 'pl',
      publisher: {
        '@type': 'Organization',
        name: 'USFansSpreadsheet',
        url: SITE_URL,
      },
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${SITE_URL}/?search={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: 'USFansSpreadsheet',
      url: SITE_URL,
      description: 'Eksperckie centrum wiedzy o arkuszach kalkulacyjnych. Porównania, rankingi i przewodniki dla użytkowników.',
      sameAs: [
        'https://kaspreadsheet.com/',
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Czy USFansSpreadsheet jest bezpieczny?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Tak, USFansSpreadsheet stosuje zaawansowane protokoły szyfrowania i regularne audyty bezpieczeństwa. Wszystkie dane użytkowników są chronione zgodnie z najwyższymi standardami branżowymi.',
          },
        },
        {
          '@type': 'Question',
          name: 'Jak działa USFansSpreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'USFansSpreadsheet to zaawansowane narzędzie do analizy danych oparte na arkuszach kalkulacyjnych. Umożliwia import, przetwarzanie i wizualizację danych w czasie rzeczywistym.',
          },
        },
        {
          '@type': 'Question',
          name: 'Czy istnieją darmowe rozwiązania USFansSpreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Tak, dostępna jest darmowa wersja USFansSpreadsheet z podstawowymi funkcjami. Dla zaawansowanych potrzeb oferowane są plany premium z dodatkowymi narzędziami analitycznymi.',
          },
        },
        {
          '@type': 'Question',
          name: 'Który arkusz wybrać dla swojej firmy?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Wybór zależy od specyfiki działalności. USFansSpreadsheet sprawdza się w e-commerce, analizie finansowej i zarządzaniu projektami. Nasz przewodnik porównawczy pomoże podjąć decyzję.',
          },
        },
        {
          '@type': 'Question',
          name: 'Jak rozpocząć korzystanie z USFansSpreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Rozpoczęcie jest proste — wystarczy odwiedzić naszą stronę, wybrać plan i postępować zgodnie z instrukcjami. Oferujemy szczegółowe samouczki oraz wsparcie techniczne.',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const scriptId = 'schema-home-jsonld';
    if (document.getElementById(scriptId)) return;
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(homeJsonLd);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(scriptId);
      if (el) document.head.removeChild(el);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleEntry />
        <TrustSection />
        <CTASection />
        <TestimonialSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}